import script from "./FileListComponentOld.vue?vue&type=script&setup=true&lang=js"
export * from "./FileListComponentOld.vue?vue&type=script&setup=true&lang=js"

import "./FileListComponentOld.vue?vue&type=style&index=0&id=4cb7a599&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cb7a599"]])

export default __exports__